const set = langCode => {
  return {
    type: 'SET_LANGUAGE',
    langCode
  }
}

export { set }
